import axios from 'axios'
import store from './store/store'
import {
  NETWORK_ERROR,
  SERVER_SIDE_ERROR,
  MAINTENACE_ERROR,
  UNAUTHORIZED_ERROR,
  UNKNOWN_ERROR
} from '@/user/store/errorTypes'

axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL
axios.defaults.headers = { 'x-ubun': 'tokyo' }

const generateUrlKey = config => {
  if (config.params) {
    return (
      config.method +
      config.url +
      Object.entries(config.params).reduce((str, [p, val], i) => {
        let value = `${str}`
        if (i > 0) {
          value += '&'
        }
        value += `${p}=${val}`
        return value
      }, '?')
    )
  }
  return config.method + config.url
}

axios.interceptors.request.use(config => {
  store.commit('SET_REQUESTING_STATUS', { [generateUrlKey(config)]: true })
  const token = store.state.auth.token
  config = {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${token}`
    }
  }
  return config
})

axios.interceptors.response.use(response => {
  store.commit('SET_REQUESTING_STATUS', { [generateUrlKey(response.config)]: false })
  return response
}, error => {
  if (error.response) {
    store.commit('SET_REQUESTING_STATUS', { [generateUrlKey(error.response.config)]: false })
    switch (error.response.status) {
      case 503:
        store.commit('SET_GLOBAL_ERROR', {
          type: MAINTENACE_ERROR,
          message: 'ただいまメンテナンス中です。'
        })
        break
      case 401:
        store.commit('SET_GLOBAL_ERROR', {
          type: UNAUTHORIZED_ERROR,
          message: 'Ubun BASE からログアウトしました。\n続行するには再度ログインしてください。'
        })
        break
      case 400:
        // サーバーサイドエラーは400で返ってくる
        // 将来的にバリデーションエラーは422で返すとかの切り分けもいいかもしれない
        store.commit('SET_GLOBAL_ERROR', {
          type: SERVER_SIDE_ERROR,
          message: error.response.data.message
        })
        break
      default:
        break
    }
  } else {
    store.commit('RESET_REQUESTING_STATUS')
    if (error.message === 'Network Error') {
      store.commit('SET_GLOBAL_ERROR', {
        type: NETWORK_ERROR,
        message: 'Ubun BASE に接続できません。ネットワークの接続を確認してください。'
      })
    } else {
      // TODO どんなときにここくるかわからないのでsentryとかでログとりたい
      console.log('response.error', error)
      store.commit('SET_GLOBAL_ERROR', {
        type: UNKNOWN_ERROR,
        message: '予期せぬエラーが発生しました。\nカスタマーサポートまでお問い合わせください。\ntech@ubun.co.jp'
      })
    }
  }
  return Promise.reject(error)
})

export default axios
